// Centralized Google AdMob Configuration for WHATIF Battle For Riches
// Console: https://admob.google.com -> Apps -> WHATIF Battle For Riches
// Official App ID: ca-app-pub-7827975555872745~4719001791


const TEST_REWARDED_ID = 'ca-app-pub-3940256099942544/5224354917'; // Official Google Test Rewarded Ad Unit
const DEFAULT_PROD_REWARDED_ID = 'ca-app-pub-7827975555872745/1977910508'; // Default Rewarded Ad Unit

// Debug builds say so in their user agent (MainActivity.java) and only ever get Google's test ads. Release
// builds get live ads, so add your own phones as test devices in AdMob and never tap a live ad.
export const IS_DEBUG_BUILD = typeof navigator !== 'undefined' && navigator.userAgent.includes('WhatifDebugBuild');

// Hard-blocked: Ads are completely disabled while WHATIF Battle For Riches is in active testing.
// No ad requests or initializations will occur, preventing invalid traffic and test impressions.
export const ADS_ENABLED = false;

export function useAdsSwitch() {
  // Permanently disabled during testing: ads remain false regardless of remote state
}

// Known Developer & Tester Device IDs for AdMob.
// In Android Logcat, search for "Use RequestConfiguration.Builder().setTestDeviceIds" to find a device's hash.
export const TEST_DEVICE_IDS = [
  // Add physical test device MD5/SHA-256 IDs here to receive test ads on physical hardware:
  // 'YOUR_DEVICE_TEST_HASH_HERE'
];

export const ADMOB_CONFIG = {
  appId: 'ca-app-pub-7827975555872745~4719001791',

  rewarded: {
    // ⚡ Speedup (Torch of Haste): Skip 30 minutes of dungeon run
    dungeonSpeedup: process.env.REACT_APP_ADMOB_SPEEDUP_ID || 'ca-app-pub-7827975555872745/1977910508',

    // 🔥 Stamina (Campfire Rest): Recover +50 Stamina
    campfireRest: process.env.REACT_APP_ADMOB_CAMPFIRE_ID || 'ca-app-pub-7827975555872745/5697663661',

    // 👑 Multiplier (Goblin's Greed): 2x Double Points and XP post-run
    dungeonDoubler: process.env.REACT_APP_ADMOB_DOUBLER_ID || 'ca-app-pub-7827975555872745/4464473046',

    // 🔮 Blessing (Shrine of the Dragon God): Pre-run Blessing
    dragonShrine: process.env.REACT_APP_ADMOB_SHRINE_ID || 'ca-app-pub-7827975555872745/9369441670',

    // 🎰 Wheel Spin (Wheel of Riches): Goblin Peddler spins
    wheelSpin: process.env.REACT_APP_ADMOB_WHEEL_ID || 'ca-app-pub-7827975555872745/3514479761',

    // 🌟 Daily Stamina Bonus (formerly faucetAd)
    dailyBonus: process.env.REACT_APP_ADMOB_DAILY_BONUS_ID || 'ca-app-pub-7827975555872745/1977910508',
  },

  getAdUnitId: (placementKey) => {
    // If running in development without production ad flags, you can use test ads
    if (IS_DEBUG_BUILD || (process.env.NODE_ENV !== 'production' && !process.env.REACT_APP_USE_PROD_ADS)) {
      return TEST_REWARDED_ID;
    }
    // Backward compatibility alias for legacy references
    if (placementKey === 'faucetAd') return ADMOB_CONFIG.rewarded.dailyBonus;
    return ADMOB_CONFIG.rewarded[placementKey] || DEFAULT_PROD_REWARDED_ID;
  }
};
